
// ***********************
// 配置参数
// ***********************

//订单状态
const OrderStatus = {
    '-1': '删除',
    '0': '已付款未签合同',
    '1': '已付款已签合同',
    '2': '未付款已签合同',
    '3': '未付款未签合同',
};

//行程单状态
const ItinerariesStatus = {
    '0': '游玩中',
    '1': '已组团',
    '2': '未组团',
    '3': '已结束',
    '4': '已退单',
    '5': '已删除',
}

//获取订单状态中文配置
const GetOrderStatus = (obj) => {
    return Object.values(OrderStatus)[obj];
}

//获取行程单状态中文配置
const GetItinerariesStatus = (obj) => {
    return Object.values(ItinerariesStatus)[obj];
}

export default {
    GetOrderStatus,
    GetItinerariesStatus,
    OrderStatus,
    ItinerariesStatus
};


// WEBPACK FOOTER //
// ./src/js/status.js